import { takeLatest, call, put } from "redux-saga/effects";
import {
	fetchUserRolesFailure,
	fetchUserRolesStart,
	fetchUserRolesSuccess,
	fetchUserGroupsStart,
	fetchUserGroupsSuccess,
	fetchUserGroupsFailure,
	fetchUserDiscountsStart,
	fetchUserDiscountsCompleted,
	fetchUserDiscountsFailure,
	authenticateUserRoleStart,
	authenticateUserRoleFailure,
	authenticateUserRoleCompleted,
} from "./user.slice";
import UserApi from "./user.api";

export function* getfetchUserRoles({ payload }): any {
	try {
		const response = yield call(UserApi.GetUserRoles);
		yield put(fetchUserRolesSuccess({ data: response.data }));
	} catch (error: any) {
		yield put(fetchUserRolesFailure({ error }));
	}
}

export function* getUserGroups({ payload }): any {
	try {
		const response = yield call(UserApi.GetUserGroups);
		yield put(fetchUserGroupsSuccess({ data: response.data }));
	} catch (error: any) {
		yield put(fetchUserGroupsFailure({ error }));
	}
}

export function* getUserDiscounts({ payload }): any {
	try {
		const response = yield call(UserApi.GetUserDiscounts);
		yield put(fetchUserDiscountsCompleted({ data: response.data }));
	} catch (error: any) {
		yield put(fetchUserDiscountsFailure({ error }));
	}
}

export function* authenticateUserRole({ payload }): any {
	try {
		const { username, password, role } = payload;

		const response = yield call(
			UserApi.AuthenticateUserRole,
			username,
			password,
			role
		);
		if (response.data.ok) {
			yield put(authenticateUserRoleCompleted({ data: response.data.results }));
		} else {
			yield put(authenticateUserRoleFailure({ error: response.data.message }));
		}
	} catch (error: any) {
		yield put(authenticateUserRoleFailure({ error }));
	}
}

export function* watchUser() {
	return [
		yield takeLatest(fetchUserRolesStart, getfetchUserRoles),
		yield takeLatest(fetchUserGroupsStart, getUserGroups),
		yield takeLatest(fetchUserDiscountsStart, getUserDiscounts),
		yield takeLatest(authenticateUserRoleStart, authenticateUserRole),
	];
}
